import { ThemeType } from '../../types';

export const darkTheme = {
  // background
  backgroundDefaultDefault: '#151318',
  backgroundDefaultDefaultHover: '#1F1F21',
  backgroundDefaultSecondary: '#1F1F21',
  backgroundDefaultSecondaryHover: '#414142',
  backgroundDefaultTertiary: '#414142',
  backgroundDefaultTertiaryHover: '#626264',

  backgroundDisabledDefault: '#1F1F21',

  backgroundBrandDefault: '#B8E1FF',
  backgroundBrandHover: '#DFF0FF',
  backgroundBrandSecondary: '#0996EE',
  backgroundBrandSecondaryHover: '#33B0FD',
  backgroundBrandTertiary: '#0076CC',
  backgroundBrandTertiaryHover: '#0996EE',

  backgroundNeutralDefault: '#B2B2B2',
  backgroundNeutralHover: '#949494',
  backgroundNeutralSecondary: '#303030',
  backgroundNeutralSecondaryHover: '#242424',
  backgroundNeutralTertiary: '#303030',
  backgroundNeutralTertiaryHover: '#242424',

  backgroundPositiveDefault: '#23850E',
  backgroundPositiveHover: '#1B5C0E',
  backgroundPositiveSecondary: '#13340D',
  backgroundPositiveSecondaryHover: '#1B5C0E',
  backgroundPositiveTertiary: '#0F1F0D',
  backgroundPositiveTertiaryHover: '#13340D',

  backgroundWarningDefault: '#CDA90E',
  backgroundWarningHover: '#FDD10E',
  backgroundWarningSecondary: '#6C5A0D',
  backgroundWarningSecondaryHover: '#6C5A0D',
  backgroundWarningTertiary: '#231F0D',
  backgroundWarningTertiaryHover: '#3B330D',

  backgroundDangerDefault: '#B73907',
  backgroundDangerHover: '#8C2E08',
  backgroundDangerSecondary: '#36170B',
  backgroundDangerSecondaryHover: '#61220A',
  backgroundDangerTertiary: '#20110C',
  backgroundDangerTertiaryHover: '#36170B',

  backgroundUtilitiesScrim: '#000000CC',
  backgroundUtilitiesBlanket: '#000000B2',
  backgroundUtilitiesOverlay: '#00000080',
  backgroundUtilitiesOverlayLight: '#0000004D',

  // icon
  iconDefaultDefault: '#FFFFFF',
  iconDefaultSecondary: '#FFFFFFB2',
  iconDefaultTertiary: '#FFFFFF66',

  iconDisableDefault: '#626264',

  iconBrandDefault: '#68C3FF',
  iconBrandSecondary: '#B8E1FF',
  iconBrandTertiary: '#33B0FD',
  iconBrandOnBrand: '#0A4370',
  iconBrandOnBrandSecondary: '#DFF0FF',
  iconBrandOnBrandTertiary: '#DFF0FF',

  iconNeutralDefault: '#E3E3E3',
  iconNeutralSecondary: '#CDCDCD',
  iconNeutralTertiary: '#B2B2B2',
  iconNeutralOnNeutral: '#242424',
  iconNeutralOnNeutralSecondary: '#F3F3F3',
  iconNeutralOnNeutralTertiary: '#F3F3F3',

  iconPositiveDefault: '#99EB87',
  iconPositiveSecondary: '#70E257',
  iconPositiveTertiary: '#33D60F',
  iconPositiveOnPositive: '#EBFBE7',
  iconPositiveOnPositiveSecondary: '#99EB87',
  iconPositiveOnPositiveTertiary: '#33D60F',

  iconWarningDefault: '#FFFBC2',
  iconWarningSecondary: '#FFF388',
  iconWarningTertiary: '#FEDF56',
  iconWarningOnWarning: '#3B330D',
  iconWarningOnWarningSecondary: '#FEDF56',
  iconWarningOnWarningTertiary: '#FDD10E',

  iconDangerDefault: '#F1A282',
  iconDangerSecondary: '#EB7D50',
  iconDangerTertiary: '#E24505',
  iconDangerOnDanger: '#FCECE6',
  iconDangerOnDangerSecondary: '#EB7D50',
  iconDangerOnDangerTertiary: '#E24505',

  // text
  textDefaultDefault: '#FFFFFF',
  textDefaultSecondary: '#FFFFFFB2',
  textDefaultTertiary: '#FFFFFF66',

  textDisabledDefault: '#626264',
  textDisabledOnDisabled: '#848485',

  textBrandDefault: '#68C3FF',
  textBrandSecondary: '#B8E1FF',
  textBrandTertiary: '#33B0FD',
  textBrandOnBrand: '#0A4370',
  textBrandOnBrandSecondary: '#DFF0FF',
  textBrandOnBrandTertiary: '#DFF0FF',

  textNeutralDefault: '#E3E3E3',
  textNeutralSecondary: '#CDCDCD',
  textNeutralTertiary: '#B2B2B2',
  textNeutralOnNeutral: '#242424',
  textNeutralOnNeutralSecondary: '#F3F3F3',
  textNeutralOnNeutralTertiary: '#F3F3F3',

  textDangerDefault: '#E24505',
  textDangerSecondary: '#EB7D50',
  textDangerTertiary: '#B73907',
  textDangerOnDanger: '#FCECE6',
  textDangerOnDangerSecondary: '#F6C7B4',
  textDangerOnDangerTertiary: '#F1A282',

  textWarningDefault: '#FEDF56',
  textWarningSecondary: '#FFF388',
  textWarningTertiary: '#FDD10E',
  textWarningOnWarning: '#3B330D',
  textWarningOnWarningSecondary: '#FEDF56',
  textWarningOnWarningTertiary: '#FDD10E',

  textPositiveDefault: '#33D60F',
  textPositiveSecondary: '#70E257',
  textPositiveTertiary: '#2BAD0F',
  textPositiveOnPositive: '#EBFBE7',
  textPositiveOnPositiveSecondary: '#C2F3B7',
  textPositiveOnPositiveTertiary: '#99EB87',

  // border
  borderDefaultDefault: '#414142',
  borderDefaultSecondary: '#626264',
  borderDefaultTertiary: '#848485',

  borderDisableDefault: '#414142',

  borderBrandDefault: '#DFF0FF',
  borderBrandSecondary: '#68C3FF',
  borderBrandTertiary: '#33B0FD',

  borderNeutralDefault: '#E3E3E3',
  borderNeutralSecondary: '#5A5A5A',
  borderNeutralTertiary: '#434343',

  borderPositiveDefault: '#2BAD0F',
  borderPositiveSecondary: '#23850E',
  borderPositiveTertiary: '#1B5C0E',

  borderWarningDefault: '#FEDF56',
  borderWarningSecondary: '#9C820E',
  borderWarningTertiary: '#6C5A0D',

  borderDangerDefault: '#EB7D50',
  borderDangerSecondary: '#8C2E08',
  borderDangerTertiary: '#61220A',

  borderUtilitiesSwatch: '#FFFFFF3D',
};

export const lightTheme = {
  // background
  backgroundDefaultDefault: '#FFFFFF',
  backgroundDefaultDefaultHover: '#F4F4F4',
  backgroundDefaultSecondary: '#F4F4F4',
  backgroundDefaultSecondaryHover: '#E9E9E9',
  backgroundDefaultTertiary: '#D2D2D3',
  backgroundDefaultTertiaryHover: '#BCBCBC',

  backgroundDisabledDefault: '#E9E9E9',

  backgroundBrandDefault: '#0996EE',
  backgroundBrandHover: '#0076CC',
  backgroundBrandSecondary: '#B8E1FF',
  backgroundBrandSecondaryHover: '#68C3FF',
  backgroundBrandTertiary: '#33B0FD',
  backgroundBrandTertiaryHover: '#0996EE',

  backgroundNeutralDefault: '#5A5A5A',
  backgroundNeutralHover: '#434343',
  backgroundNeutralSecondary: '#CDCDCD',
  backgroundNeutralSecondaryHover: '#B2B2B2',
  backgroundNeutralTertiary: '#E3E3E3',
  backgroundNeutralTertiaryHover: '#CDCDCD',

  backgroundPositiveDefault: '#CDCDCD',
  backgroundPositiveHover: '#23850E',
  backgroundPositiveSecondary: '#C2F3B7',
  backgroundPositiveSecondaryHover: '#99EB87',
  backgroundPositiveTertiary: '#EBFBE7',
  backgroundPositiveTertiaryHover: '#C2F3B7',

  backgroundWarningDefault: '#FFF388',
  backgroundWarningHover: '#FEDF56',
  backgroundWarningSecondary: '#FFFBC2',
  backgroundWarningSecondaryHover: '#FFFBC2',
  backgroundWarningTertiary: '#FEFCE8',
  backgroundWarningTertiaryHover: '#FFFBC2',

  backgroundDangerDefault: '#E24505',
  backgroundDangerHover: '#B73907',
  backgroundDangerSecondary: '#F6C7B4',
  backgroundDangerSecondaryHover: '#F1A282',
  backgroundDangerTertiary: '#FCECE6',
  backgroundDangerTertiaryHover: '#F6C7B4',

  backgroundUtilitiesScrim: '#FFFFFFCC',
  backgroundUtilitiesBlanket: '#000000B2',
  backgroundUtilitiesOverlay: '#00000080',
  backgroundUtilitiesOverlayLight: '#0000004D',

  // icon
  iconDefaultDefault: '#1F1F21',
  iconDefaultSecondary: '#A5A5A6',
  iconDefaultTertiary: '#BCBCBC',

  iconDisableDefault: '#A5A5A6',

  iconBrandDefault: '#0996EE',
  iconBrandSecondary: '#0076CC',
  iconBrandTertiary: '#045088',
  iconBrandOnBrand: '#DFF0FF',
  iconBrandOnBrandSecondary: '#0A4370',
  iconBrandOnBrandTertiary: '#DFF0FF',

  iconNeutralDefault: '#303030',
  iconNeutralSecondary: '#5A5A5A',
  iconNeutralTertiary: '#767676',
  iconNeutralOnNeutral: '#FFFFFF',
  iconNeutralOnNeutralSecondary: '#303030',
  iconNeutralOnNeutralTertiary: '#434343',

  iconPositiveDefault: '#23850E',
  iconPositiveSecondary: '#2BAD0F',
  iconPositiveTertiary: '#33D60F',
  iconPositiveOnPositive: '#EBFBE7',
  iconPositiveOnPositiveSecondary: '#2BAD0F',
  iconPositiveOnPositiveTertiary: '#23850E',

  iconWarningDefault: '#9C820E',
  iconWarningSecondary: '#CDA90E',
  iconWarningTertiary: '#FDD10E',
  iconWarningOnWarning: '#3B330D',
  iconWarningOnWarningSecondary: '#6C5A0D',
  iconWarningOnWarningTertiary: '#9C820E',

  iconDangerDefault: '#8C2E08',
  iconDangerSecondary: '#B73907',
  iconDangerTertiary: '#E24505',
  iconDangerOnDanger: '#FCECE6',
  iconDangerOnDangerSecondary: '#8C2E08',
  iconDangerOnDangerTertiary: '#B73907',

  // text
  textDefaultDefault: '#1F1F21',
  textDefaultSecondary: '#626264',
  textDefaultTertiary: '#A5A5A6',

  textDisabledDefault: '#A5A5A6',
  textDisabledOnDisabled: '#A5A5A6',

  textBrandDefault: '#0076CC',
  textBrandSecondary: '#005EA5',
  textBrandTertiary: '#0A4370',
  textBrandOnBrand: '#DFF0FF',
  textBrandOnBrandSecondary: '#045088',
  textBrandOnBrandTertiary: '#DFF0FF',

  textNeutralDefault: '#303030',
  textNeutralSecondary: '#5A5A5A',
  textNeutralTertiary: '#767676',
  textNeutralOnNeutral: '#FFFFFF',
  textNeutralOnNeutralSecondary: '#303030',
  textNeutralOnNeutralTertiary: '#434343',

  textDangerDefault: '#B73907',
  textDangerSecondary: '#8C2E08',
  textDangerTertiary: '#E24505',
  textDangerOnDanger: '#FCECE6',
  textDangerOnDangerSecondary: '#8C2E08',
  textDangerOnDangerTertiary: '#B73907',

  textWarningDefault: '#9C820E',
  textWarningSecondary: '#6C5A0D',
  textWarningTertiary: '#CDA90E',
  textWarningOnWarning: '#3B330D',
  textWarningOnWarningSecondary: '#6C5A0D',
  textWarningOnWarningTertiary: '#9C820E',

  textPositiveDefault: '#23850E',
  textPositiveSecondary: '#1B5C0E',
  textPositiveTertiary: '#2BAD0F',
  textPositiveOnPositive: '#EBFBE7',
  textPositiveOnPositiveSecondary: '#1B5C0E',
  textPositiveOnPositiveTertiary: '#23850E',

  // border
  borderDefaultDefault: '#D2D2D3',
  borderDefaultSecondary: '#BCBCBC',
  borderDefaultTertiary: '#A5A5A6',

  borderDisableDefault: '#E9E9E9',

  borderBrandDefault: '#005EA5',
  borderBrandSecondary: '#0996EE',
  borderBrandTertiary: '#0996EE',

  borderNeutralDefault: '#303030',
  borderNeutralSecondary: '#767676',
  borderNeutralTertiary: '#949494',

  borderPositiveDefault: '#23850E',
  borderPositiveSecondary: '#2BAD0F',
  borderPositiveTertiary: '#FEDF56',

  borderWarningDefault: '#CDA90E',
  borderWarningSecondary: '#FDD10E',
  borderWarningTertiary: '#6C5A0D',

  borderDangerDefault: '#B73907',
  borderDangerSecondary: '#EB7D50',
  borderDangerTertiary: '#F1A282',

  borderUtilitiesSwatch: '#0000003D',
};
function setCSSVariables(theme: { [key: string]: string }) {
  if (typeof document !== 'undefined') {
    Object.keys(theme).forEach((key) => {
      const cssVarName = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      document.documentElement.style.setProperty(`--sds-color-${cssVarName}`, theme[key]);
    });
  }
}

export function initTheme(themeType?: ThemeType) {
  let theme = undefined;
  console.log('wfs==inject themeType', themeType, typeof document);
  if (themeType === 'dark') {
    theme = darkTheme;
    // inject custom properties
    if (typeof document !== 'undefined') {
      document.documentElement.style.setProperty(
        '--Loading-Skeleton-BG',
        'linear-gradient(90deg, rgba(65, 65, 66, 0.30) 0%, rgba(98, 98, 100, 0.30) 50%, rgba(65, 65, 66, 0.30) 100%)',
      );
      document.documentElement.style.setProperty('--Border-Brand-Button-Default-Inner', '#062A4B');
      document.documentElement.style.setProperty('--Border-Default-Subtle', '#414142');
    }
  } else {
    theme = lightTheme;
    // inject custom properties
    if (typeof document !== 'undefined') {
      document.documentElement.style.setProperty(
        '--Loading-Skeleton-BG',
        'linear-gradient(90deg, rgba(233, 233, 233, 0.30) 0%, rgba(188, 188, 188, 0.30) 50%, rgba(233, 233, 233, 0.30) 100%)',
      );
      document.documentElement.style.setProperty('--Border-Brand-Button-Default-Inner', '#FFFFFF');
      document.documentElement.style.setProperty('--Border-Default-Subtle', '#E9E9E9');
    }
  }
  setCSSVariables(theme);
}

export const DEFAULT_THEME: ThemeType = 'light';
